import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Utente } from 'src/app/models/utente';
import { Pwd } from 'src/app/models/pwd';
import { ResetPassword } from 'src/app/models/reset-password';
@Injectable({
  providedIn: 'root',
})
export class UtentiService {
  utentiUrl = environment.ildatoArticoliDpi + 'api/user';
  getMeUrl = environment.ildatoArticoliDpi + 'api/user/getMe';
  modPasswordUrl = environment.ildatoArticoliDpi + 'api/user/modificaPassword';

  private http = inject(HttpClient);

  list(): Observable<Utente[]> {
    return this.http.get<Utente[]>(this.utentiUrl + '/list');
  }

  getMe(): Observable<Utente> {
    return this.http.get<Utente>(this.getMeUrl);
  }

  cambioPassword(values: Pwd): Observable<boolean> {
    return this.http.put<boolean>(`${this.modPasswordUrl}`, values);
  }

  remove(idUtente: number): Observable<Utente> {
    return this.http.delete<Utente>(this.utentiUrl + '/delete/' + idUtente);
  }
  update(idUtente: number, utente: Utente): Observable<Utente> {
    return this.http.put<Utente>(
      this.utentiUrl + '/update/' + idUtente,
      utente,
    );
  }
  insert(utente: Utente): Observable<Utente> {
    return this.http.post<Utente>(this.utentiUrl + '/insert', utente);
  }

  resetPassword(key: number, newPwd: ResetPassword): Observable<Utente> {
    return this.http.put<Utente>(
      this.utentiUrl + '/resetpassword/' + key,
      newPwd,
    );
  }
}
